import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import {HeaderComponent} from '../components/header/header.component';
import {Router, RouterLink, RouterOutlet} from '@angular/router';
import {SidebarComponent} from '../components/sidebar/sidebar.component';
import {TranslatePipe} from '@ngx-translate/core';
import {ServiceProviderHub} from '@generated-backend-types';
import {LocaleService} from '../services/locale-service/locale.service';
import {UserSessionService} from '../services/user-session-service/user-session.service';
import {AppVersionService} from '../services/app-version/app-version.service';
import {TitleService} from '../services/title-service/title.service';
import AuthenticatedContact = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Auth.AuthenticatedContact;

@Component({
  selector: 'app-authenticated',
  imports: [
    HeaderComponent,
    RouterOutlet,
    SidebarComponent,
    RouterLink,
    TranslatePipe
  ],
  standalone: true,
  templateUrl: './authenticated.component.html'
})
export class AuthenticatedComponent implements OnInit {
  private readonly titleService = inject(TitleService);
  private readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly userSessionService = inject(UserSessionService);
  private readonly localeService = inject(LocaleService);
  private readonly appVersionService = inject(AppVersionService);

  isCollapsed = true
  @ViewChild('contentHeaderTemplate') contentHeaderTemplate!: TemplateRef<string>;
  public user?: Partial<AuthenticatedContact>
  public locale: "de" | "en";
  public appVersion: string = '';
  public currentYear = (new Date()).getUTCFullYear();

  public constructor() {
    const localeService = this.localeService;


    this.titleService.setTitle(' ');

    this.router.events.subscribe(
      () => {
        this.isCollapsed = true
        this.cdr.markForCheck()
      }
    )

    this.locale = localeService.currentLocale
    localeService.localeChanged.subscribe(
      l => this.locale = l
    )
  }

  public switchLang(lang: 'de' | 'en'): void {
    this.localeService.setLocale(lang)
  }

  public ngOnInit() {
    this.userSessionService.getStoredUserInfo().subscribe({
      next: value => {
        this.user = value
        this.cdr.markForCheck()
      }
    });

    this.appVersionService.getVersion().subscribe(version => {
      this.appVersion = version;
      this.cdr.markForCheck();
    });
  }

  public headerHeight() {
    return document.getElementById('header-height')?.scrollHeight
  }
}
